import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=646c7f71"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=646c7f71&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('646c7f71')) {
      api.createRecord('646c7f71', component.options)
    } else {
      api.reload('646c7f71', component.options)
    }
    module.hot.accept("./menu.vue?vue&type=template&id=646c7f71", function () {
      api.rerender('646c7f71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/public/main/components/side-menu/menu.vue"
export default component.exports